export default "__VITE_ASSET__MjhceOpE__"